import { render } from "./Declined.vue?vue&type=template&id=8e74eec6&scoped=true"
import script from "./Declined.vue?vue&type=script&lang=js"
export * from "./Declined.vue?vue&type=script&lang=js"

import "./Declined.vue?vue&type=style&index=0&id=8e74eec6&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e74eec6"]])

export default __exports__